import backgroundPicture from './../assets/backgroundPicture.png';

type Props = {}

function TickLabel({ }: Props) {

    const infoMeasure = {
        title: "MEASURE",
        text: 'Motions, feedbacks and documentation.'
    } as const;
    const infoReport = {
        title: "REPORT",
        text: 'The moment easily and quickly.'
    } as const;
    const infoBenchmark = {
        title: "BENCHMARK",
        text: 'Identifying areas of improvement and opportunities.'
    } as const;
    const infoOptimize = {
        title: "OPTIMIZE",
        text: 'Maximizing the ROI and achieving goals.'
    } as const;
    const infoPlan = {
        title: "PLAN",
        text: 'Future events with learning agenda, reviews and continuous optimization.'
    } as const;

    return (
        <div className='relative w-screen overflow-hiddenh-auto'>
            <img src={backgroundPicture} className='absolute inset-0 w-fit h-[740px] md:h-[840px] xl:h-fit object-cover z-0'/>
            <div className="absolute top-20 left-10 xl:left-60 flex flex-col xl:w-[487px] z-10">
                <span className="font-bold text-neonGreen text-3xl xl:text-5xl">{infoMeasure.title}</span>
                <span className='font-regular text-white text-xl xl:text-2xl w-2/3 xl:w-fit'>{infoMeasure.text}</span>
            </div>
            <div className="absolute top-48 xl:top-52 xl:top-44 left-20 xl:left-1/2 flex flex-col xl:w-[487px] z-10">
                <span className="font-bold text-neonGreen text-3xl xl:text-5xl">{infoReport.title}</span>
                <span className='font-regular text-white text-xl xl:text-2xl w-3/4 xl:w-fit'>{infoReport.text}</span>
            </div>      
            <div className="absolute top-[305px] left-10 xl:left-60 flex flex-col xl:w-[487px] z-10">
                <span className="font-bold text-neonGreen text-3xl xl:text-5xl">{infoBenchmark.title}</span>
                <span className='font-regular text-white text-xl xl:text-2xl w-11/12 xl:w-fit'>{infoBenchmark.text}</span>
            </div>
            <div className="absolute top-[450px] left-20 xl:left-1/2 flex flex-col xl:w-[487px] z-10">
                <span className="font-bold text-neonGreen text-3xl xl:text-5xl">{infoOptimize.title}</span>
                <span className='font-regular text-white text-xl xl:text-2xl'>{infoOptimize.text}</span>
            </div>
            <div className="absolute top-[570px] left-10 xl:left-60 flex flex-col xl:w-[487px] z-10">
                <span className="font-bold text-neonGreen text-3xl xl:text-5xl">{infoPlan.title}</span>
                <span className='font-regular text-white text-xl xl:text-2xl w-3/4 xl:w-fit'>{infoPlan.text}</span>
            </div>
        </div>
    )
}

export default TickLabel